import { FC, PropsWithChildren, useContext } from 'react';
import { Box, IconButton, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NavigationContext } from '../../../providers/NavigationProvider';
import React from 'react';
import ModalPortal from '../ModalPortal/ModalPortal';

interface ModalProps extends PropsWithChildren {
  title: string;
  closeModal: () => void;
  zeroPaddingBody?: boolean;
  zeroOverflowBody?: boolean;
}

const Modal: FC<ModalProps> = ({
  title,
  closeModal,
  children,
  zeroPaddingBody
}) => {
  const navContextData = useContext(NavigationContext);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));

  return (
    <ModalPortal>
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          [theme.breakpoints.down('tablet')]: {
            padding: "2%"
          },
          ...(navContextData?.navExpanded && {
            ...(!isTablet && {
              padding: "48px 48px 48px 348px"
            }),
          }),
          ...(!navContextData?.navExpanded && {
            ...(!isTablet && {
              padding: "48px 48px 48px 113px"
            }),
          })
        })}>
        <Paper
          sx={{
            width: "min(100%, 1800px)",
            backgroundColor: "white",
            minHeight: "250px",
            maxHeight: "calc(100vh - 100px)",
            overflow: "hidden"
          }}>
          <Stack
            direction="row"
            sx={(theme) => ({
              justifyContent: "center",
              alignItems: "center",
              height: "72px",
              minHeight: "72px",
              maxHeight: '72px',
              backgroundColor: theme.colors.primary,
              color: "white",
              padding: "0px 24px 0px 48px"
            })}>
            {(React.isValidElement(title)) &&
              <>{title}</>
            }
            {(!React.isValidElement(title)) &&
              <Typography
                variant='primaryFont'
                sx={{
                  width: "100%",
                  textTransform: "uppercase",
                  margin: 0
                }}>
                {title}
              </Typography>
            }
            <IconButton
              sx={{
                color: "white"
              }}
              onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            direction="column"
            id="modalContent"
            sx={(theme) => ({
              overflow: 'auto',
              padding: zeroPaddingBody ? 0 : "48px 4%",
              height: "fit-content",
              maxHeight: "calc(100vh - 268px)",
              [theme.breakpoints.down('tablet')]: {
                height: "fit-content",
                maxHeight: "calc(100vh - 268px)",
              }

            })}>
            {children}
          </Stack>
        </Paper>
      </Box>
    </ModalPortal>
  )
};

export default Modal;
